export default __webpack_public_path__ + "static/media/close.9941a7f1.svg";